import { run as runCookieConsent, acceptedCategory, showPreferences } from 'vanilla-cookieconsent'
import { handleAttributionCookies } from './attribution'

const COOKIE_CONFIG = {
  TRACKING_COOKIES: ['th_attribution'],
  COOKIE_PATH: '/',
  EXPIRED_DATE: 'Thu, 01 Jan 1970 00:00:00 GMT',
}

export function initCookieConsent() {
  runCookieConsent({
    guiOptions: {
      consentModal: {
        layout: 'bar',
        position: 'bottom',
        flipButtons: false,
        equalWeightButtons: false,
        closeIconLabel: 'Close banner',
      },
    },

    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {
        enabled: true,
      },
      marketing: {
        enabled: true,
      },
    },

    language: {
      default: 'en',
      translations: {
        en: {
          consentModal: {
            title: 'We value your privacy 🌍',
            description:
              "We use cookies to enhance your travel planning experience and show you personalized content. Choose what you're comfortable with - you can change this anytime.",
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Essential only',
            showPreferencesBtn: 'Manage preferences',
          },
          preferencesModal: {
            title: 'Your Cookie Preferences',
            acceptAllBtn: '', // Hide this button
            acceptNecessaryBtn: '', // Hide this button
            savePreferencesBtn: 'Save preferences',
            sections: [
              {
                title: 'How we use cookies',
                description:
                  "Cookies help us deliver the best possible experience on TourHero. Choose which types of cookies you're comfortable with - you can change these settings anytime.",
              },
              {
                title: 'Essential cookies',
                description:
                  "Help keep TourHero working properly - things like staying logged in and keeping your cart items safe. We can't turn these off.",
                linkedCategory: 'necessary',
              },
              {
                title: 'Analytics & Performance',
                description:
                  'Help us understand how travelers use TourHero so we can make it even better. We see which pages are popular and how travelers navigate the site.',
                linkedCategory: 'analytics',
              },
              {
                title: 'Marketing & Advertising',
                description:
                  'Help us show you relevant travel offers and measure our advertising effectiveness. We may share this data with our trusted partners.',
                linkedCategory: 'marketing',
              },
            ],
          },
        },
      },
    },

    onConsent: function () {
      updateConsentIntegrations()
      handleAttributionCookies()
    },

    onChange: function ({ changedCategories: _changedCategories }) {
      updateConsentIntegrations()

      // If analytics was rejected, clean up GA cookies
      if (!acceptedCategory('analytics')) {
        clearGoogleAnalyticsCookies()
        clearAttributionCookies()
      } else {
        handleAttributionCookies()
      }
    },
  })
}

function updateConsentIntegrations() {
  const consentSignals = computeConsentSignals()

  updateGoogleConsent(consentSignals)
  updateClarityConsent(consentSignals)
}

function computeConsentSignals() {
  return {
    analyticsGranted: acceptedCategory('analytics') ? 'granted' : 'denied',
    adStorageGranted: acceptedCategory('marketing') ? 'granted' : 'denied',
  }
}

function updateGoogleConsent({ analyticsGranted, adStorageGranted }) {
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      analytics_storage: analyticsGranted,
      ad_storage: adStorageGranted,
      ad_user_data: adStorageGranted,
      ad_personalization: adStorageGranted,
    })
  }

  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: 'consent_update',
      analytics_storage: analyticsGranted,
      ad_storage: adStorageGranted,
    })
  }
}

function updateClarityConsent({ analyticsGranted, adStorageGranted }) {
  const consentPayload = {
    analytics_Storage: analyticsGranted,
    ad_Storage: adStorageGranted,
  }

  applyClarityConsent(consentPayload)
}

function applyClarityConsent(consentPayload) {
  if (!consentPayload || typeof window.clarity !== 'function') {
    return
  }

  window.clarity('consentv2', consentPayload)
}

function clearGoogleAnalyticsCookies() {
  const gaCookies = ['_ga', '_gid', '_gat', '_gac_']

  document.cookie.split(';').forEach(function (cookie) {
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim()

    if (gaCookies.some(gaCookie => name.startsWith(gaCookie))) {
      // Delete the cookie
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' + window.location.hostname
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.' + window.location.hostname
    }
  })
}

export function isAnalyticsAllowed() {
  return acceptedCategory('analytics')
}

export function isMarketingAllowed() {
  return acceptedCategory('marketing')
}

export function showCookiePreferences() {
  showPreferences()
}

function clearAttributionCookies() {
  COOKIE_CONFIG.TRACKING_COOKIES.forEach(cookieName => {
    // Delete the cookie across different domain variations
    document.cookie = `${cookieName}=; expires=${COOKIE_CONFIG.EXPIRED_DATE}; path=${COOKIE_CONFIG.COOKIE_PATH}`
    document.cookie = `${cookieName}=; expires=${COOKIE_CONFIG.EXPIRED_DATE}; path=${COOKIE_CONFIG.COOKIE_PATH}; domain=${window.location.hostname}`
    document.cookie = `${cookieName}=; expires=${COOKIE_CONFIG.EXPIRED_DATE}; path=${COOKIE_CONFIG.COOKIE_PATH}; domain=.${window.location.hostname}`
  })
}
